import { render, staticRenderFns } from "./irv-result-list-component.vue?vue&type=template&id=d7954e30&scoped=true"
import script from "./irv-result-list-component.ts?vue&type=script&lang=ts&external"
export * from "./irv-result-list-component.ts?vue&type=script&lang=ts&external"
import style0 from "./irv-result-list-component.scss?vue&type=style&index=0&id=d7954e30&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7954e30",
  null
  
)

export default component.exports